import Box, { BoxProps } from '@mui/material/Box'
import { alpha, useTheme } from '@mui/material/styles'

export function ImageGlowWrapper(props: BoxProps) {
  const { children, sx, ...rest } = props
  const theme = useTheme()

  return (
    <Box
      sx={{
        my: { xs: 5, md: 10 },
        borderRadius: 2,
        boxShadow: `0px 0px 25px 10px ${alpha(theme.palette.common.white, 0.24)}`,
        ...sx
      }}
      {...rest}
    >
      {children}
    </Box>
  )
}
